// extracted by mini-css-extract-plugin
export default {"cards":"cash-flow_cards__gJBr9","title":"cash-flow_title__+77S-","legendTitle":"cash-flow_legendTitle__g9XZi","cashFlowChart":"cash-flow_cashFlowChart__4wEQe"};